import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Button } from "@mui/material";
import { decrement, increment, reset, incrementByAmount } from "../../store/myFeatureSlice";
import { useState } from "react";

function ReduxLerning() {
    const count = useSelector((state: RootState) => state.counter.value);
    const dispatch = useDispatch();
    const [step, setStep] = useState(5);
    return (
        <div>
            <h1>Redux Lerning</h1>
            <h1>Current Count: {count}</h1>
            <Button onClick={() => dispatch(increment())}>Increment</Button>
            <Button onClick={() => dispatch(decrement())}>Decrement</Button>
            <Button onClick={() => dispatch(reset())}>Reset</Button>
            <Button onClick={() => dispatch(incrementByAmount(10))}>Increment By Amount</Button>
            <input
  type="number"
  value={step}
  onChange={(e) => setStep(Number(e.target.value))}
/>
<Button onClick={() => dispatch(incrementByAmount(step))}>
  Add by {step}
</Button>
        </div>
    )
}
export default ReduxLerning;



// import React, { useState } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { RootState } from '../../store';
// import { increment, decrement } from '../../store/myFeatureSlice';
// import {
//     Box,
//     Card,
//     CardContent,
//     Typography,
//     Button,
//     Grid,
//     Paper,
//     Divider,
//     Chip,
//     Alert,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     List,
//     ListItem,
//     ListItemText,
//     ListItemIcon
// } from '@mui/material';
// import {
//     Add as AddIcon,
//     Remove as RemoveIcon,
//     Store as StoreIcon,
//     PlayArrow as PlayIcon,
//     Code as CodeIcon,
//     Info as InfoIcon
// } from '@mui/icons-material';

// function ReduxLerning() {
//     // Redux state and dispatch
//     const count = useSelector((state: RootState) => state.counter.value);
//     const dispatch = useDispatch();
    
//     // Local state for learning
//     const [actionHistory, setActionHistory] = useState<string[]>([]);

//     const addToHistory = (action: string) => {
//         setActionHistory(prev => [...prev, `${new Date().toLocaleTimeString()}: ${action}`]);
//     };

//     const handleIncrement = () => {
//         dispatch(increment());
//         addToHistory('dispatch(increment())');
//     };

//     const handleDecrement = () => {
//         dispatch(decrement());
//         addToHistory('dispatch(decrement())');
//     };

//     const resetHistory = () => {
//         setActionHistory([]);
//     };

//     return (
//         <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
//             <Typography variant="h3" gutterBottom align="center" color="primary">
//                 🎓 Redux Learning Playground
//             </Typography>
            
//             <Alert severity="info" sx={{ mb: 3 }}>
//                 <Typography variant="h6">Welcome to Redux Learning!</Typography>
//                 <Typography>
//                     This page demonstrates Redux concepts in action using your existing counter slice. 
//                     You can see the store state, dispatch actions, and watch how the state changes in real-time.
//                 </Typography>
//             </Alert>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//                 {/* Current State Display */}
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
//                     <Box sx={{ flex: 1 }}>
//                         <Card elevation={3}>
//                         <CardContent>
//                             <Typography variant="h5" gutterBottom>
//                                 <StoreIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                                 Current Redux State
//                             </Typography>
//                             <Paper 
//                                 sx={{ 
//                                     p: 2, 
//                                     bgcolor: 'primary.light', 
//                                     color: 'white',
//                                     textAlign: 'center',
//                                     mb: 2
//                                 }}
//                             >
//                                 <Typography variant="h4">
//                                     Counter: {count}
//                                 </Typography>
//                             </Paper>
//                             <Typography variant="body2" color="text.secondary">
//                                 This value comes from: <code>useSelector((state: RootState) =&gt; state.counter.value)</code>
//                             </Typography>
//                         </CardContent>
//                         </Card>
//                     </Box>

//                     {/* Action Buttons */}
//                     <Box sx={{ flex: 1 }}>
//                     <Card elevation={3}>
//                         <CardContent>
//                             <Typography variant="h5" gutterBottom>
//                                 <PlayIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                                 Dispatch Actions
//                             </Typography>
//                             <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
//                                 <Button
//                                     variant="contained"
//                                     color="success"
//                                     startIcon={<AddIcon />}
//                                     onClick={handleIncrement}
//                                     size="large"
//                                 >
//                                     Increment (+1)
//                                 </Button>
//                                 <Button
//                                     variant="contained"
//                                     color="error"
//                                     startIcon={<RemoveIcon />}
//                                     onClick={handleDecrement}
//                                     size="large"
//                                 >
//                                     Decrement (-1)
//                                 </Button>
//                             </Box>
//                             <Typography variant="body2" color="text.secondary">
//                                 These buttons dispatch actions to the Redux store
//                             </Typography>
//                         </CardContent>
//                         </Card>
//                     </Box>
//                 </Box>

//                 {/* Action History */}
//                 <Card elevation={3}>
//                     <CardContent>
//                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                             <Typography variant="h5">
//                                 Action History
//                             </Typography>
//                             <Button 
//                                 variant="outlined" 
//                                 size="small" 
//                                 onClick={resetHistory}
//                             >
//                                 Clear History
//                             </Button>
//                         </Box>
//                         <Paper sx={{ maxHeight: 200, overflow: 'auto', p: 1 }}>
//                             {actionHistory.length === 0 ? (
//                                 <Typography color="text.secondary" align="center">
//                                     No actions dispatched yet. Click the buttons above!
//                                 </Typography>
//                             ) : (
//                                 <List dense>
//                                     {actionHistory.map((action, index) => (
//                                     <ListItem key={index}>
//                                         <ListItemIcon>
//                                             <Chip 
//                                                 label={index + 1} 
//                                                 size="small" 
//                                                 color="primary" 
//                                             />
//                                         </ListItemIcon>
//                                         <ListItemText 
//                                             primary={action}
//                                             secondary={`Action #${index + 1}`}
//                                         />
//                                     </ListItem>
//                                     ))}
//                                 </List>
//                             )}
//                         </Paper>
//                     </CardContent>
//                 </Card>

//                 {/* Redux Concepts Explanation */}
//                 <Card elevation={3}>
//                     <CardContent>
//                         <Typography variant="h5" gutterBottom>
//                             <InfoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                             Redux Concepts Explained
//                         </Typography>
                        
//                         <Accordion>
//                                 <AccordionSummary expandIcon={<CodeIcon />}>
//                                     <Typography variant="h6">1. Your Store Configuration</Typography>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                     <Typography paragraph>
//                                         Your Redux store is configured with a counter reducer. Here's how it's set up:
//                                     </Typography>
//                                     <Paper sx={{ p: 2, bgcolor: 'grey.100' }}>
//                                         <Typography variant="body2" component="pre">
// {`// Your store configuration (src/store/index.ts)
// const store = configureStore({
//     reducer: {
//         counter: counterReducer
//     }
// });`}
//                                         </Typography>
//                                     </Paper>
//                                 </AccordionDetails>
//                             </Accordion>

//                             <Accordion>
//                                 <AccordionSummary expandIcon={<CodeIcon />}>
//                                     <Typography variant="h6">2. Your Counter Slice</Typography>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                     <Typography paragraph>
//                                         Your counter slice defines the initial state and reducers:
//                                     </Typography>
//                                     <Paper sx={{ p: 2, bgcolor: 'grey.100' }}>
//                                         <Typography variant="body2" component="pre">
// {`// Your counter slice (src/store/myFeatureSlice/index.ts)
// export const counterSlice = createSlice({
//     name: 'counter',
//     initialState: {
//         value: 0
//     },
//     reducers: {
//         increment: state => {
//             state.value += 1
//         },
//         decrement: (state) => {
//             state.value -= 1
//         }
//     }
// })`}
//                                         </Typography>
//                                     </Paper>
//                                 </AccordionDetails>
//                             </Accordion>

//                             <Accordion>
//                                 <AccordionSummary expandIcon={<CodeIcon />}>
//                                     <Typography variant="h6">3. How to Use in Components</Typography>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                     <Typography paragraph>
//                                         Here's how you connect components to your Redux store:
//                                     </Typography>
//                                     <Paper sx={{ p: 2, bgcolor: 'grey.100' }}>
//                                         <Typography variant="body2" component="pre">
// {`// Reading state
// const count = useSelector((state: RootState) => state.counter.value);

// // Dispatching actions
// const dispatch = useDispatch();
// dispatch(increment());
// dispatch(decrement());`}
//                                         </Typography>
//                                     </Paper>
//                                 </AccordionDetails>
//                             </Accordion>

//                             <Accordion>
//                                 <AccordionSummary expandIcon={<CodeIcon />}>
//                                     <Typography variant="h6">4. Data Flow</Typography>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                     <Typography paragraph>
//                                         When you click a button, this is what happens:
//                                     </Typography>
//                                     <Paper sx={{ p: 2, bgcolor: 'grey.100' }}>
//                                         <Typography variant="body2" component="pre">
// {`1. User clicks "Increment" button
// 2. handleIncrement() function is called
// 3. dispatch(increment()) sends action to store
// 4. counterSlice reducer processes the action
// 5. State updates: { value: 0 } → { value: 1 }
// 6. Component re-renders with new value
// 7. Action is logged to history`}
//                                         </Typography>
//                                     </Paper>
//                                 </AccordionDetails>
//                             </Accordion>
//                         </CardContent>
//                     </Card>

//                 {/* Data Flow Diagram */}
//                 <Card elevation={3}>
//                     <CardContent>
//                         <Typography variant="h5" gutterBottom>
//                             Redux Data Flow
//                         </Typography>
//                         <Box sx={{ textAlign: 'center', p: 2 }}>
//                             <Typography variant="body1" sx={{ mb: 2 }}>
//                                 <strong>User Action</strong> → <strong>Dispatch</strong> → <strong>Reducer</strong> → <strong>New State</strong> → <strong>Component Re-renders</strong>
//                             </Typography>
//                             <Divider sx={{ my: 2 }} />
//                             <Typography variant="body2" color="text.secondary">
//                                 Every time you click a button, this entire cycle happens automatically!
//                             </Typography>
//                         </Box>
//                     </CardContent>
//                 </Card>
//             </Box>
//         </Box>
//     );
// }

// export default ReduxLerning;